const bitrixActionConst = [
  // ########### Сделки
  {
    value: 'action_oncrmdealadd',
    label: 'Создать сделку',
    field: [
      { value: 'title', label: 'Название сделки' },
      { value: 'type_id', label: 'Тип сделки' },
      { value: 'category_id', label: 'Воронка' },
      { value: 'stage_id', label: 'Стадия сделки' },
      { value: 'opportunity', label: 'Сумма' },
      { value: 'tax_value', label: 'Сумма налога' },
      { value: 'comments', label: 'Комментарий' },
      { value: 'assigned_by_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_oncrmdealupdate',
    label: 'Обновить сделку',
    field: [
      { value: 'title', label: 'Название сделки' },
      { value: 'type_id', label: 'Тип сделки' },
      { value: 'category_id', label: 'Воронка' },
      { value: 'stage_id', label: 'Стадия сделки' },
      { value: 'opportunity', label: 'Сумма' },
      { value: 'tax_value', label: 'Сумма налога' },
      { value: 'comments', label: 'Комментарий' },
      { value: 'assigned_by_id', label: 'Ответственный за сделку' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_oncrmdealdelete',
    label: 'Удалить сделку',
    field: [],
  },
  // ########### Контакты
  {
    value: 'action_oncrmcontactadd',
    label: 'Создать контакт',
    field: [
      { value: 'name', label: 'Имя' },
      { value: 'second_name', label: 'Отчество' },
      { value: 'last_name', label: 'Фамилия' },
      { value: 'birthdate', label: 'Дата рождения' },
      { value: 'type_id', label: 'Тип контакта' },
      { value: 'source_id', label: 'Источник' },
      { value: 'post', label: 'Должность' },
      { value: 'comments', label: 'Комментарий' },
      { value: 'phone', label: 'Телефон' },
      { value: 'email', label: 'E-mail' },
      { value: 'assigned_by_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_oncrmcontactupdate',
    label: 'Обновить контакт',
    field: [
      { value: 'name', label: 'Имя' },
      { value: 'second_name', label: 'Отчество' },
      { value: 'last_name', label: 'Фамилия' },
      { value: 'birthdate', label: 'Дата рождения' },
      { value: 'type_id', label: 'Тип контакта' },
      { value: 'source_id', label: 'Источник' },
      { value: 'post', label: 'Должность' },
      { value: 'comments', label: 'Комментарий' },
      { value: 'phone', label: 'Телефон' },
      { value: 'email', label: 'E-mail' },
      { value: 'assigned_by_id', label: 'Ответственный за контакт' },
      { value: 'field_by_id', label: 'Указать поле по ID' },
    ],
  },
  {
    value: 'action_oncrmcontactdelete',
    label: 'Удалить контакт',
    field: [],
  },
  // ########### Дело
  {
    value: 'action_oncrmactivityadd',
    label: 'Создать дело',
    field: [
      { value: 'deadline', label: 'Дата и время срока исполнения дела' },
      { value: 'description', label: 'Текстовое описание дела' },
      { value: 'responsible_id', label: 'Ответственный за дело' },
    ],
  },
  {
    value: 'action_oncrmactivityupdate',
    label: 'Обновить дело',
    field: [
      { value: 'deadline', label: 'Дата и время срока исполнения дела' },
      { value: 'description', label: 'Текстовое описание дела' },
      { value: 'responsible_id', label: 'Ответственный за дело' },
    ],
  },
  {
    value: 'action_oncrmactivitydelete',
    label: 'Удалить дело',
    field: [],
  },
  // ########### Таймлайны
  {
    value: 'action_oncrmtimelinecommentadd',
    label: 'Добавить новый комментарий в таймлайне',
    field: [],
  },
  // ########### Компании
  // { value: 'action_ONCRMCOMPANYADD', label: 'Создать компанию' },
  // { value: 'action_ONCRMCOMPANYUPDATE', label: 'Обновить компанию' },
  // { value: 'action_ONCRMCOMPANYDELETE', label: 'Удалить компанию' },
  // ########### Лиды
  // { value: 'ONCRMLEADADD', label: 'Создание лида' },
  // { value: 'ONCRMLEADUPDATE', label: 'Обновление лида' },
  // { value: 'ONCRMLEADDELETE', label: 'Удаление лида' },
  // ########### Счета
  // { value: 'ONCRMINVOICEADD', label: 'Создание счета' },
  // { value: 'ONCRMINVOICEUPDATE', label: 'Обновление счета' },
  // { value: 'ONCRMINVOICEDELETE', label: 'Удаление счета' },
  // { value: 'ONCRMINVOICESETSTATUS', label: 'Обновление статуса счета' },
  // ########### Пользовательские поля
  // { value: 'ONCRMLEADUSERFIELDADD', label: 'Добавление пользовательского поля в событиях' },
  // { value: 'ONCRMLEADUSERFIELDUPDATE', label: 'Изменение пользовательского поля в событиях' },
  // { value: 'ONCRMLEADUSERFIELDDELETE', label: 'Удаление пользовательского поля в событиях' },
  // { value: 'ONCRMLEADUSERFIELDSETENUMVALUES', label: 'Изменение набора пользовательского поля в сделках' },
  // { value: 'ONCRMDEALUSERFIELDADD', label: 'Добавление пользовательского поля в сделках' },
  // { value: 'ONCRMDEALUSERFIELDUPDATE', label: 'Изменение пользовательского поля в сделках' },
  // { value: 'ONCRMDEALUSERFIELDDELETE', label: 'Удаление пользовательского поля в сделках' },
  // { value: 'ONCRMDEALUSERFIELDSETENUMVALUES', label: 'Изменении набора значений поля в сделках' },
  // { value: 'ONCRMCOMPANYUSERFIELDADD', label: 'Добавлении пользовательского поля событий компании' },
  // { value: 'ONCRMCOMPANYUSERFIELDUPDATE', label: 'Изменение пользовательского поля событий компании' },
  // { value: 'ONCRMCOMPANYUSERFIELDDELETE', label: 'Удаление пользовательского поля событий компании' },
  // { value: 'ONCRMCOMPANYUSERFIELDSETENUMVALUES', label: 'Изменение набора для поля компании' },
  // { value: 'ONCRMCONTACTUSERFIELDADD', label: 'Добавление пользовательского поля контактов' },
  // { value: 'ONCRMCONTACTUSERFIELDUPDATE', label: 'Изменение пользовательского поля контактов' },
  // { value: 'ONCRMCONTACTUSERFIELDDELETE', label: 'Удаление пользовательского поля контактов' },
  // { value: 'ONCRMCONTACTUSERFIELDSETENUMVALUES', label: 'Изменении значений пользовательского поля контактов' },
  // { value: 'ONCRMQUOTEUSERFIELDADD', label: 'Добавление пользовательского поля коммерческого предложения' },
  // { value: 'ONCRMQUOTEUSERFIELDUPDATE', label: 'Изменение пользовательского поля коммерческого предложения' },
  // { value: 'ONCRMQUOTEUSERFIELDDELETE', label: 'Удаление набора пользовательского поля коммерческого предложения' },
  // { value: 'ONCRMQUOTEUSERFIELDSETENUMVALUES', label: 'Изменение набора пользовательского поля коммерческого предложения' },
  // { value: 'ONCRMINVOICEUSERFIELDADD', label: 'Добавление пользовательского поля счета' },
  // { value: 'ONCRMINVOICEUSERFIELDUPDATE', label: 'Изменение пользовательского поля счета' },
  // { value: 'ONCRMINVOICEUSERFIELDDELETE', label: 'Удаление пользовательского поля счета' },
  // { value: 'ONCRMREQUISITEUSERFIELDADD', label: 'Добавление пользовательского поля' },
  // { value: 'ONCRMREQUISITEUSERFIELDUPDATE', label: 'Изменение пользовательского поля' },
  // { value: 'ONCRMREQUISITEUSERFIELDDELETE', label: 'Удаление пользовательского поля' },
  // { value: 'ONCRMREQUISITEUSERFIELDSETENUMVALUES', label: 'Изменение набора значений для пользовательского поля списочного типа' },
  // { value: 'ONCRMTYPEUSERFIELDADD', label: 'Добавление настройки пользовательского поля смарт-процессов' },
  // { value: 'ONCRMTYPEUSERFIELDUPDATE', label: 'Обновление настройки  пользовательского поля смарт-процессов' },
  // { value: 'ONCRMTYPEUSERFIELDDELETE', label: 'Удаление настройки пользовательского поля смарт-процессов' },
  // { value: 'ONCRMTYPEUSERFIELDSETENUMVALUES', label: 'Настройка пользовательского поля смарт-процессов' },
  // ########### Коммерческое предложение
  // { value: 'ONCRMQUOTEADD', label: 'Создание коммерческого предложения' },
  // { value: 'ONCRMQUOTEUPDATE', label: 'Изменение коммерческого предложения' },
  // { value: 'ONCRMQUOTEDELETE', label: 'Удаление коммерческого предложения' },
  // ###########
  // { value: 'ONCRMINVOICEUSERFIELDSETENUMVALUES', label: 'Изменение поля списочного типа' },
  // ########### Валюты
  // { value: 'ONCRMCURRENCYADD', label: 'Создание валюты' },
  // { value: 'ONCRMCURRENCYUPDATE', label: 'Обновление валюты' },
  // { value: 'ONCRMCURRENCYDELETE', label: 'Удаление валюты' },
  // ########### Товары
  // { value: 'ONCRMPRODUCTADD', label: 'Создание товара' },
  // { value: 'ONCRMPRODUCTUPDATE', label: 'Обновление товара' },
  // { value: 'ONCRMPRODUCTDELETE', label: 'Удаление товара' },
  // { value: 'ONCRMPRODUCTPROPERTYADD', label: 'Добавление свойства товара' },
  // { value: 'ONCRMPRODUCTPROPERTYUPDATE', label: 'Изменение свойства товара' },
  // { value: 'ONCRMPRODUCTPROPERTYDELETE', label: 'Удаление свойства товара' },
  // { value: 'ONCRMPRODUCTSECTIONADD', label: 'Добавление раздела' },
  // { value: 'ONCRMPRODUCTSECTIONUPDATE', label: 'Изменение раздела' },
  // { value: 'ONCRMPRODUCTSECTIONDELETE', label: 'Удаление раздела' },
  // ########### Реквизити
  // { value: 'ONCRMREQUISITEADD', label: 'Добавление реквизита' },
  // { value: 'ONCRMREQUISITEUPDATE', label: 'Обновление реквизита' },
  // { value: 'ONCRMREQUISITEDELETE', label: 'Удаление реквизита' },
  // ########### Банковские реквизити
  // { value: 'ONCRMBANKDETAILADD', label: 'Добавление банковского реквизита' },
  // { value: 'ONCRMBANKDETAILUPDATE', label: 'Обновление банковского реквизита' },
  // { value: 'ONCRMBANKDETAILDELETE', label: 'Удаление банковского реквизита' },
  // ########### Адрес
  // { value: 'ONCRMADDRESSREGISTER', label: 'Регистрация адреса'},
  // { value: 'ONCRMADDRESSUNREGISTER', label: 'Удаление адреса' },
  // ########### Единица измерения
  // { value: 'ONCRMMEASUREADD', label: 'Добавление единицы измерения' },
  // { value: 'ONCRMMEASUREUPDATE', label: 'Изменение единицы измерения' },
  // { value: 'ONCRMMEASUREDELETE', label: 'Удаления единицы измерения' },
  // ########### Регулярные сделки
  // { value: 'ONCRMDEALRECURRINGADD', label: 'Создание новой регулярной сделки' },
  // { value: 'ONCRMDEALRECURRINGUPDATE', label: 'Обновление регулярной сделки' },
  // { value: 'ONCRMDEALRECURRINGDELETE', label: 'Удаление регулярной сделки' },
  // {  value: 'ONCRMDEALRECURRINGEXPOSE', label: 'Создание новой сделки из регулярной сделки' },
  // { value: 'ONCRMINVOICERECURRINGADD', label: 'Создание нового регулярного счета' },
  // { value: 'ONCRMINVOICERECURRINGUPDATE', label: 'Обновление регулярного счета' },
  // { value: 'ONCRMINVOICERECURRINGDELETE', label: 'Удаление регулярного счета' },
  // { value: 'ONCRMINVOICERECURRINGEXPOSE', label: 'Выставление нового счета из регулярного счета' },
  // ########### Смарт-процессы
  // { value: 'ONCRMDYNAMICITEMADD', label: 'Добавление элемента смарт-процесса' },
  // { value: 'ONCRMDYNAMICITEMUPDATE', label: 'Изменение элемента смарт-процесса' },
  // { value: 'ONCRMDYNAMICITEMDELETE', label: 'Удаление элемента смарт-процесса' },
  // { value: 'ONCRMTYPEADD', label: 'Создание нового смарт-процесса' },
  // { value: 'ONCRMTYPEUPDATE', label: 'Изменении настроек смарт-процесса' },
  // { value: 'ONCRMTYPEDELETE', label: 'Удаление смарт-процесса' },
  // ########### Документы
  // { value: 'ONCRMDOCUMENTGENERATORDOCUMENTADD', label: 'Создание нового документа' },
  // { value: 'ONCRMDOCUMENTGENERATORDOCUMENTUPDATE', label: 'Изменение документа' },
  // { value: 'ONCRMDOCUMENTGENERATORDOCUMENTDELETE', label: 'Удаление документа' },
]

export default bitrixActionConst
